/**
 * Determines the installType for APP products
 * Unified Details Service V3 will directly return the installType for APP products
 * But until then, we're calculating it on the FE to have the future proof expected prop for the AppCTAButton
 *
 * installType replaces ConnectButton.tsx logic that considered:
 * - homemade (defined in Admin Tool)
 * - connectionType (HOMEMADE_IFRAME, HOMEMADE_MODAL, HOMEMADE_EXTERNAL, STANDARD)
 * - isOpsHub (Data Sync team API)
 * - isDashworks (Data Sync team API)
 * - appUrl (Listing Editor)
 *
 * New installType values:
 * - HOMEMADE_DATA_SYNC: For Data Sync apps (detected via opsHub field)
 * - HOMEMADE_DASHWORKS: For Dashworks apps (detected via dashworks field)
 * - STANDARD: OAuth redirect flow (connectionType=STANDARD without appUrl, we make an additional API call to get the OAuth URL)
 * - LEGACY: Legacy appUrl redirect (connectionType=STANDARD with appUrl)
 * - HOMEMADE_EXTERNAL: connectionType=HOMEMADE_EXTERNAL
 * - HOMEMADE_MODAL: connectionType=HOMEMADE_MODAL
 * - HOMEMADE_IFRAME: connectionType=HOMEMADE_IFRAME
 * - HOMEMADE_PREINSTALLED: connectionType=HOMEMADE_PREINSTALLED
 * - HOMEMADE_UNIFIED_ACCOUNT: connectionType=HOMEMADE_UNIFIED_ACCOUNT
 */
export function getAppInstallType({
  connectionType,
  isDashworks,
  isMcpServer,
  isOpsHub,
  isStandardizedInstall,
  isPreviewAndOptedInToStandardInstall,
  isUnifiedAccount
}) {
  // Check for Data Sync apps (opsHub field from Data Sync team API)
  if (isOpsHub) {
    return 'HOMEMADE_DATA_SYNC';
  }
  // Check for Dashworks apps (dashworks field from Data Sync team API)
  if (isDashworks) {
    return 'HOMEMADE_DASHWORKS';
  }
  // Check for MCP Server apps
  if (isMcpServer) {
    return 'HOMEMADE_MCP_SERVER';
  }
  // Check for builtByHubSpot apps migrated to UnifiedAccount
  if (isUnifiedAccount) {
    return 'HOMEMADE_UNIFIED_ACCOUNT';
  }
  // Standard connection type handling
  if (connectionType === 'STANDARD') {
    if (isStandardizedInstall || isPreviewAndOptedInToStandardInstall) {
      // Standard OAuth flow - we make a call in AppCTAButton to get the OAuth URL
      return 'STANDARD';
    }
    if (isStandardizedInstall === false) {
      // Legacy flow - we use the installUrl (formerly appUrl) as the href for the button
      return 'LEGACY';
    }
  }
  // Homemade connection types
  if (connectionType === 'HOMEMADE_EXTERNAL') {
    return 'HOMEMADE_EXTERNAL';
  }
  if (connectionType === 'HOMEMADE_MODAL') {
    return 'HOMEMADE_MODAL';
  }
  if (connectionType === 'HOMEMADE_IFRAME') {
    return 'HOMEMADE_IFRAME';
  }
  if (connectionType === 'HOMEMADE_PREINSTALLED') {
    return 'HOMEMADE_PREINSTALLED';
  }
  if (connectionType === 'HOMEMADE_UNIFIED_ACCOUNT') {
    return 'HOMEMADE_UNIFIED_ACCOUNT';
  }
  return 'STANDARD';
}